import { useEffect, useState } from "react";
import { IMAGE_BASE } from "../utils/constants";

export const ImageCell = ({ logo_url, alt = "image", width = 24, height = 16, style = {} }) => {
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    if (!logo_url) return;

    const finalUrl = logo_url.startsWith("http")
      ? logo_url
      : `${IMAGE_BASE}${logo_url}`;

    const fetchImage = async () => {
      try {
        const response = await fetch(finalUrl);
        if (!response.ok || !response.headers.get("content-type")?.startsWith("image")) {
          throw new Error("Invalid image response");
        }
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        setImageSrc(url);
      } catch (err) {
        console.error("Failed to fetch image", err);
        setImageSrc(null);
      }
    };

    fetchImage();

    return () => {
      if (imageSrc) {
        URL.revokeObjectURL(imageSrc);
      }
    };
  }, [logo_url]);

  if (!imageSrc) return <span>No Image</span>;

  return (
    <img
      src={imageSrc}
      alt={alt}
      width={width}
      height={height}
      style={{ objectFit: "cover", borderRadius: "3px", ...style }}
    />
  );
};

